const BrokerDashboard = () => import('~/pages/broker-portal/BrokerDashboard');
const BrokerFirmOrderEditPage = () => import('~/pages/broker-portal/BrokerFirmOrderEdit');
const BrokerContract = () => import('~/pages/broker-portal/BrokerContract');
const CompanyPartyView = () => import('~/pages/broker-portal/CompanyPartyView');
const DepartmentPartyView = () => import('~/pages/broker-portal/DepartmentPartyView');
const Home = () => import('~/pages/Home');
const InsurerDashboard = () => import('~/pages/insurer-portal/InsurerDashboard');
//const InsurerReportsDashboard = () => import('~/pages/insurer-portal/InsurerReportsDashboard');
const InsurerContract = () => import('~/pages/insurer-portal/InsurerContract');
//const InsurerSecurityDashboard = () => import('~/pages/insurer-portal/InsurerSecurityDashboard');
//const FacilityManager = () => import('~/pages/broker-portal/FacilityManager');
const ForgotPassword = () => import('~/pages/ForgotPassword');
const Login = () => import('~/pages/Login');
const Notifications = () => import('~/pages/Notifications');
//const Reports = () => import('~/pages/Reports');
const ResetPasswordForm = () => import('~/pages/ResetPassword');
const UpdateExpiredPasswordForm = () => import('~/pages/ExpiredPassword');
const UnauthorisedPage = () => import('~/pages/UnauthorisedPage');
const ContactManagement = () => import('~/pages/ContactManagement');
const FacilityManager = () => import('~/pages/broker-portal/FacilityOutlineManager');
const SecurityManager = () => import('~/pages/SecurityManager');
//const EventsDashboard = () => import('~/pages/EventsDashboard');
const EventsView = () => import('~/pages/EventsView');
const TasksView = () => import('~/pages/TasksView');
//const BasicTasksDashboard = () => import('~/pages/BasicTasksDashboard')
const SelectFollowers = () => import('~/components/Broker/SelectFollowers')
const CookiePolicy = () => import('~/pages/CookiePolicy')


import advancedActivities from '~/middleware/advancedActivities';
import basicActivities from '~/middleware/basicActivities';

export default [
    {
        path: '/home',
        name: 'home',
        meta: {
            layout: 'standard'
        },
        component: Home
    },
    {
        path: '/login',
        alias: '/',
        name: 'login',
        meta: {
            layout: 'login'
        },
        component: Login,
    },
    {
        path: '/forgot-password',
        name: 'forgot-password',
        component: ForgotPassword,
        meta: {
            layout: 'login'
        }
    },
    {
        path: '/reset-password/:token',
        name: 'reset-password-form',
        component: ResetPasswordForm,
        meta: {
            layout: 'login'
        }
    },
    {
        path: '/update-expired-password',
        name: 'update-expired-password-form',
        component: UpdateExpiredPasswordForm,
        meta: {
            layout: 'login'
        }
    },
    {
        path: '/agent/dashboard',
        name: 'broker-dashboard',
        meta: {
            layout: 'standard'
        },
        component: BrokerDashboard
    },
    {
        path: '/agent/contract/:id',
        name: 'broker-contract',
        meta: {
            layout: 'standard'
        },
        component: BrokerContract
    },

    // {
    //     path: '/agent/facility-manager',
    //     name: 'facility-manager',
    //     meta: {
    //         layout: 'standard'
    //     },
    //     component: FacilityManager
    // },
    // {
    //     path: '/insurer/reports',
    //     name: 'insurer-reports',
    //     meta: {
    //         layout: 'standard'
    //     },
    //     component: Reports
    // },
    // {
    //     path: '/agent/reports',
    //     name: 'agent-reports',
    //     meta: {
    //         layout: 'standard'
    //     },
    //     component: Reports
    // },
    {
        path: '/agent/firm-order/:id/edit',
        name: 'broker-firm-order-edit',
        meta: {
            layout: 'standard'
        },
        component: BrokerFirmOrderEditPage
    },
    {
        path: '/insurer/dashboard',
        name: 'insurer-dashboard',
        meta: {
            layout: 'standard'
        },
        component: InsurerDashboard,
    },
    {
        path: '/insurer/contract/:id/offer/:offerId',
        name: 'insurer-open-market-contract',
        meta: {
            layout: 'standard'
        },
        component: InsurerContract
    },
    {
        path: '/insurer/participation/:id',
        name: 'insurer-participation',
        meta: {
            layout: 'standard'
        },
        component: InsurerContract
    },
    {
        path: '/insurer/contract/:id/offer/:offerId/facility-participation/:facilityParticipationId',
        name: 'insurer-facility-contract',
        meta: {
            layout: 'standard'
        },
        component: InsurerContract
    },
    {
        path: '/insurer/contract/:id/offer/:offerId/edit',
        name: 'insurer-edit-contract',
        meta: {
            layout: 'standard'
        },
        component: InsurerContract
    },
    {
        path: '/insurer/security-manager',
        name: 'insurer-security-manager',
        meta: {
            layout: 'standard'
        },
        component: SecurityManager,
    },
    // {
    //     path: '/insurer/reports',
    //     name: 'underwriting-reports',
    //     meta: {
    //         layout: 'standard'
    //     },
    //     component: InsurerReportsDashboard
    // },
    {
        path: '/notifications',
        name: 'notifications',
        meta: {
            layout: 'standard'
        },
        component: Notifications
    },
    {
        path: '/unauthorised',
        name: 'unauthorised',
        component: UnauthorisedPage
    },
    {
        path: '/agent/contact-management',
        name: 'contact-management',
        meta: {
            layout: 'standard'
        },
        component: ContactManagement
    },
    {
        path: '/agent/facility-manager',
        name: 'facility-management',
        meta: {
            layout: 'standard'
        },
        component: FacilityManager
    },
    {
        path: '/broker/security-manager',
        name: 'broker-security-management',
        meta: {
            layout: 'standard'
        },
        component: SecurityManager
    },
    // {
    //     path: '/events/dashboard',
    //     name: 'events-dashboard',
    //     meta: {
    //         layout: 'standard',
    //         middleware: advancedActivities,
    //     },
    //     component: EventsDashboard
    // },
    {
        path: '/events/:id',
        name: 'events-view',
        meta: {
            layout: 'standard',
            middleware: advancedActivities,
        },
        component: EventsView
    },
    {
        path: '/tasks/:id',
        name: 'tasks-view',
        meta: {
            layout: 'standard',
            middleware: advancedActivities,
        },
        component: TasksView
    },
    // {
    //     path: '/basic/tasks/dashboard',
    //     name: 'basic-tasks-dashboard',
    //     meta: {
    //         layout: 'standard',
    //         middleware: basicActivities,
    //     },
    //     component: BasicTasksDashboard
    // },
    {
        path: '/company/party/:id',
        name: 'company-party-view',
        meta: {
            layout: 'standard'
        },
        component: CompanyPartyView
    },
    {
        path: '/department/party/:id',
        name: 'department-party-view',
        meta: {
            layout: 'standard'
        },
        component: DepartmentPartyView
    },
    {
        path: '/agent/contract/:id/offer/:offer_id',
        name: 'broker-offer',
        meta: {
            layout: 'standard'
        },
        component: SelectFollowers
    },
    {
        path: '/cookie-policy',
        name: 'cookie-policy',
        meta: {
            layout: 'standard'
        },
        component: CookiePolicy
    }
];
